import { render, staticRenderFns } from "./VlGenerateTemplateModal.vue?vue&type=template&id=118c4e4f&scoped=true&"
import script from "./VlGenerateTemplateModal.vue?vue&type=script&lang=js&"
export * from "./VlGenerateTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c4e4f",
  null
  
)

export default component.exports